import { DamageDetailBase } from './damage-detail-base.class';
import { DamageEstimationBase } from './damage-estimation-base.class';
export class DamageBase {
    damages = [];
    estimation;
    part = {
        description: 'Front Bumper',
        id: 'front_bumper',
        zone: 'front'
    };
    image_info;
    constructor(base = {}) {
        this.estimation = new DamageEstimationBase(base.estimation);
        this.damages = (base.damages || []).map((damage) => new DamageDetailBase(damage));
        this.part = base.part ?? this.part;
        this.image_info = base.image_info || {};
        if (!this.damages.length) {
            this.damages.push(new DamageDetailBase());
        }
    }
}
